export const orderPermissionsData = [
  {
    name: 'WLS pre-validation',
    permissions: [
      {
        id: 1,
        name: 'Bypass Pending Validation',
        description:
          'The orders will be submitted directly and the "Pending Validation" status will be skipped'
      }
    ]
  }
];
